import { render } from "./WaitingFor.vue?vue&type=template&id=a28245ca&ts=true"
import script from "./WaitingFor.vue?vue&type=script&lang=ts"
export * from "./WaitingFor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__